import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MeAviseTipo } from '@app/models/me-avise-tipo.model';
import { MeAviseTipoService } from '@app/services/me-avise-tipo.service';

@Component({
  selector: 'app-me-avise-tipo-form',
  templateUrl: './me-avise-tipo-form.component.html'
})
export class MeAviseTipoFormComponent implements OnInit {

  aguardandoSolicitacao: boolean = false;
  lstErros: string[];
  meAviseTipo: MeAviseTipo;
  titulo: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private meAviseTipoServico: MeAviseTipoService
  ) {
    this.meAviseTipo = new MeAviseTipo();
    this.meAviseTipo.Ativo = true;
  }

  ngOnInit() {
    const id = this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Tipo de Me Avise' : 'Novo Tipo de Me Avise';

      if (!id) {
        return;
      }

      this.meAviseTipoServico.obterPorId(id).toPromise().then(
        data => this.meAviseTipo = data,
        data => this.router.navigate(['./configuracoes/me-avise-tipo']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.meAviseTipoServico.gravar(this.meAviseTipo).toPromise().then(
      () => this.router.navigate(['./configuracoes/me-avise-tipo']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      }
    );
  }
}
